import React, { Component } from 'react';  
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';

class EncyclopediaDetail extends Component {
  componentWillMount() {
    document.getElementsByTagName('title')[0].innerHTML = "百科详情";
  }
  goBack = () => {
     hashHistory.goBack();
  }

  render() {
    return (
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>百科详情</span>
            </div>
            <div>
              
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent">
          <div dangerouslySetInnerHTML={{__html: this.props.location.state.content}} style={{WebkitFlex: 1, fontSize: 18, paddingLeft: 13, paddingRight: 13, paddingTop: 13, paddingBottom: 13}} />
        </div>
      </div>
    );
  }
}

export default EncyclopediaDetail;


// WEBPACK FOOTER //
// ./src/components/recommend/EncyclopediaDetail.js